import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IAnnotationReviewStore } from '../annotationReview.store';
import { ReviewMode } from '../models/reviewMode';

interface IProps {
  correctBuilder(): ReactElement;
  reviewBuilder(): ReactElement;
}

export const ReviewModeSwitchContainer = observer((props: IProps): ReactElement => {
  const annotationReviewStore = useInjection(IAnnotationReviewStore.$);

  switch (annotationReviewStore.currentMode) {
    case ReviewMode.Correct:
      return props.correctBuilder();
    case ReviewMode.Review:
      return props.reviewBuilder();
    default:
      throw new Error('This review mode is unknown in this area');
  }
});
